let priceCustom = "";
let processingCustom = "";
class BundleProduct extends HTMLElement {
  constructor() {
    super();
    this.highestProperties = undefined;

    document.addEventListener("Option:VariantChange", (e) => {
      this.UpdateBulkItemSelection(e.detail.variant, e.detail.element);
      
      if (!e.detail.variant) return;
      if (e.detail.variant.sku && e.detail.element) {
        let parentForm = e.detail.element.closest("form");
        let sku_element = parentForm.querySelector("[data-itemsku]");
        if (sku_element) sku_element.textContent = e.detail.variant.sku;
      }
      let closestform = e.detail.element?.closest("form");
      if (closestform) {
        let individual_btn = closestform.querySelector(
          "button[data-individual-atc]"
        ); 
        if (individual_btn)
          individual_btn.setAttribute("data-variant-id", e.detail.variant.id);
      }
      
    });
window.customElements.whenDefined('variant-selects').then(() => {
      
      setTimeout(() => {
      const variantSelects = this.querySelectorAll('variant-selects');
      if (variantSelects.length > 0) {
        variantSelects.forEach(variantSelect => {
          variantSelect.dispatchEvent(new Event('change'));
          });
        }
      }, 1000);
    });
  }

  /**
   * Setup quantity handlers for both bundle and individual quantity inputs
   * @param {HTMLElement} container - The container element to setup handlers for
   * @param {boolean} isBundle - Whether this is the bundle quantity (true) or individual quantity (false)
   */



  setupQuantityHandlers(container, isBundle) {
    // Setup quantity button handlers
    container.querySelectorAll("[data-qty-btn]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        const qtyInput = container.querySelector("[data-qty-input]");
        let qtyValue = Number(qtyInput.value);
        if (btn.dataset.for === "increase") {
          qtyInput.value = qtyValue + 1;
        } else if (btn.dataset.for === "decrease" && qtyValue > 1) {
          qtyInput.value = qtyValue - 1;
        }
        // Update bundle price if this is the bundle quantity
        if (isBundle) {
          const updateQty = Number(qtyInput.value);
          this.updateBundlePrice(updateQty);
        }
      });
    });

    // Setup quantity input change handlers
    container.querySelectorAll("[data-qty-input]").forEach((input) => {
      input.addEventListener("change", () => {
        // Ensure minimum value of 1
        if (input.value < 1) input.value = 1;
        if (isBundle) {
          const updateQty = Number(input.value);
          this.updateBundlePrice(updateQty);
        }
      });
    });
  }

  connectedCallback() {
    this.product_id = this.dataset.pid;
    this.pricing = this.dataset.pricing;
    priceCustom = this.dataset.pricing;
    this.basePrice = Number(this.dataset.baseprice);
    this.comparePrice = Number(this.dataset.compareprice);
    this.processing_time = this.dataset.processingtime;
    processingCustom = this.dataset.processingtime;
    this.bundle_availability = this.dataset.outofstock;
    this.bundletype = this.dataset.bundletype;


    this.variableBox = {};
    this.variableBox.totalItems = this.querySelectorAll(
      "form.bulk-item-form"
    ).length;
    this.variableBox.verifiedItems = [];

    for (let i = 0; i < this.variableBox.totalItems; i++) {
      let hasSelectedVariant =
        this.querySelector(`[data-itemindex="${i}"] [name="id"]`)?.value ||
        false;
      if (hasSelectedVariant) {
        this.variableBox.verifiedItems[i] = this.querySelector(
          `[data-itemindex="${i}"] [name="id"]`
        )?.value;
      } else {
        this.variableBox.verifiedItems[i] =
          this.querySelector(`[data-itemindex="${i}"] [data-selectedid]`)
            .dataset.selectedid || false;
      }
    }

    this.variableBox.bundle_is_available = false;

    this.variableBox.properties = {
      _product_id: this.product_id,
      _unique_id: undefined,
      _bundle_price: this.pricing,
    };

    if (this.processing_time != "nil")
      this.variableBox.properties["_processing_time"] = this.processing_time;
    this.variableBox.submitBtn = this.querySelector(
      "button[data-bulkaddtocart]"
    );
    this.variableBox.submitBtnText = this.querySelector(
      "button[data-bulkaddtocart] [data-addtocart-text]"
    );
    this.variableBox.submitBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (this.bundle_availability == "true") return;
      this.verifyData();
    });

    const bundleQuantityWrapper = this.querySelector(".form-submit-wrapper");
    this.setupQuantityHandlers(bundleQuantityWrapper, true);

    this.initializeIndividualATC();

    // Load bundle data asynchronously with loading state
    this.setAttribute('data-bundle-loading', 'true');
    window.ensureBundleDataLoaded()
      .then(() => {
        this.setAttribute('data-bundle-loading', 'false');
        console.log('Bundle data loaded successfully');
      })
      .catch((error) => {
        this.setAttribute('data-bundle-error', 'true');
        this.setAttribute('data-bundle-loading', 'false');
        console.error('Failed to load bundle data:', error);
      });
  }

  static async getEligibleBundleProductId() {
    try {
    // Ensure bundle data is loaded before accessing
    await window.ensureBundleDataLoaded();

    const response = await fetch("/cart.js");
    const cart = await response.json();

    if (!window.bundleProducts || !cart?.items?.length) return null;

    // Build a map of eligible cart items (productId => count)
    const eligibleCartItems = cart.items.reduce((acc, item) => {
      if (item.properties?._bundle_unique_id) return acc;

      const productId = item.product_id?.toString();
      if (!productId) return acc;

      acc[productId] = (acc[productId] || 0) + item.quantity;
      return acc;
    }, {});

    // Loop through each bundle parent
    for (const [bundleParentId, childIds] of Object.entries(window.bundleProducts)) {
      if (!bundleParentId || !childIds?.length) continue;

      // Clone counts so we don’t mutate original cart data
      const tempCounts = { ...eligibleCartItems };

      const isPerfectBundle = childIds.every((childId) => {
        const id = childId.toString();

        if (!tempCounts[id]) return false;

        tempCounts[id] -= 1; // consume item
        return true;
      });

      if (isPerfectBundle) {
        return bundleParentId.toString(); // ✅ PERFECT bundle found
      }
    }

    return null;
  } catch (err) {
    console.error("Error finding perfect bundle:", err);
    return null;
  }
  }

static async getCorrectCompleteBundleParent(bundleParentId) {

  try {
    // Ensure bundle data is loaded before accessing
    await window.ensureBundleDataLoaded();

    if (!window.bundleProducts) return null;

    const parentId = bundleParentId?.toString();
    if (!parentId) return null;

    const childProductIds = window.bundleProducts[parentId];
    if (!Array.isArray(childProductIds) || !childProductIds.length) {
      console.warn("No child products found for bundle:", parentId);
      return null;
    }

    const normalizedChildIds = childProductIds.map(String);

    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    if (!cart?.items?.length) return null;

    /* ------------------------------------------
       SEPARATE BUNDLE vs NON-BUNDLE ITEMS
    ------------------------------------------ */
    const existingBundles = cart.items.filter(
      (item) =>
        item.properties?._bundle_unique_id ||
        item.properties?._unique_custom_id
    );

    const nonBundleItems = cart.items.filter(
      (item) =>
        !item.properties?._bundle_unique_id &&
        !item.properties?._unique_custom_id &&
        !item.discounts?.some((d) => d?.title === "BUNDLE_DISCOUNT")
    );

    const cartProductIds = new Set(
      nonBundleItems.map((i) => i.product_id.toString())
    );

    // Ensure all bundle child products exist in cart
    if (!normalizedChildIds.every((pid) => cartProductIds.has(pid))) {
      return null;
    }

    /* ------------------------------------------
       BUILD PRODUCT → VARIANT MAP
    ------------------------------------------ */
    const productVariantsMap = {};
    const productQuantities = {};

    normalizedChildIds.forEach((pid) => {
      const variants = nonBundleItems
        .filter((i) => i.product_id.toString() === pid)
        .map((v) => ({ ...v }));

      productVariantsMap[pid] = variants;
      productQuantities[pid] = variants.reduce((sum, v) => sum + v.quantity, 0);
    });

    const bundlesToCreate = Math.min(...Object.values(productQuantities));
    
    if (bundlesToCreate <= 0) return null;

    /* ------------------------------------------
       REMOVE MATCHED NON-BUNDLE ITEMS
    ------------------------------------------ */
    const updates = cart.items.map((item) => {
      if (
        item.properties?._unique_custom_id ||
        !nonBundleItems.find((v) => v.variant_id === item.variant_id)
      ) {
        return item.quantity;
      }

      if (normalizedChildIds.includes(item.product_id.toString())) {
        return 0;
      }

      return item.quantity;
    });

    let cartSectionID = "component-cart-drawer";
    if (window.globalSpace?.template === "cart") {
      cartSectionID =
        document.getElementById("cart--items")?.dataset.id || "template-cart";
    }

    await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates, sections: `${cartSectionID},header` }),
    });

    /* ------------------------------------------
       CREATE BUNDLES
    ------------------------------------------ */
    for (let bundleIndex = 0; bundleIndex < bundlesToCreate; bundleIndex++) {
      const random = Math.random().toString(36).substring(2, 10);
      const matchedVariantIds = [];
      const bundleItems = [];

      normalizedChildIds.forEach((pid) => {
        const variant = productVariantsMap[pid].find((v) => v.quantity > 0);
        if (!variant) return;

        variant.quantity -= 1;
        matchedVariantIds.push(String(variant.variant_id));
      });

      const uniqueId = matchedVariantIds.join(":");
      const bundleUniqueId =
        parentId + uniqueId + priceCustom + processingCustom;

      normalizedChildIds.forEach((pid) => {
        const variant = nonBundleItems.find(
          (v) =>
            matchedVariantIds.includes(String(v.variant_id)) &&
            v.product_id.toString() === pid
        );

        if (!variant) return;

        const mergedProperties = {
          _unique_id: uniqueId,
          _bundle_unique_id: bundleUniqueId + random,
          _unique_custom_id: random,
          _bundle_price: window.bundleMeta[parentId]?.pricing,
          _processing_time: window.bundleMeta[parentId]?.processing_time,
          _product_id: parentId,
        };

        if (variant.properties?.["Personalization"]) {
            mergedProperties["Personalization"] =
            variant.properties["Personalization"];
        }

        if (variant.properties?.["additional cost"]) {
          mergedProperties["additional cost"] =
            variant.properties["additional cost"];
        }

        bundleItems.push({
          id: String(variant.variant_id),
          quantity: 1,
          properties: mergedProperties,
        });
      });

      if (bundleItems.length) {
        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: bundleItems,
            sections: `${cartSectionID},header`,
          }),
        });

        sessionStorage.removeItem("NumberOnBack");
        document
          .querySelectorAll("[data-personalization-input]")
          .forEach((el) => (el.value = ""));
        document
          .querySelectorAll("[data-selected-variant]")
          .forEach((radio) => {
            if (!radio.checked) radio.click();
          });

        const dataJSON = await addRes.json();
        document.querySelector("cart-form")?._updateCart(dataJSON.sections);
      }
    }

    /* ------------------------------------------
       ADD LEFTOVER NON-BUNDLE ITEMS BACK
    ------------------------------------------ */
    const leftoverItems = [];

    Object.values(productVariantsMap)
      .flat()
      .forEach((variant) => {
        if (variant.quantity > 0) {
          leftoverItems.push({
            id: String(variant.variant_id),
            quantity: variant.quantity,
            properties: { ...variant.properties },
          });
        }
      });

    if (leftoverItems.length) {
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: leftoverItems,
          sections: `${cartSectionID},header`,
        }),
      });

      sessionStorage.removeItem("NumberOnBack");
      document
        .querySelectorAll("[data-personalization-input]")
        .forEach((el) => (el.value = ""));
      document
        .querySelectorAll("[data-selected-variant]")
        .forEach((radio) => {
          if (!radio.checked) radio.click();
        });

      const dataJSON = await addRes.json();
      document.querySelector("cart-form")?._updateCart(dataJSON.sections);
    }

    return parentId;
  } catch (err) {
    console.error("Error in getCorrectCompleteBundleParent:", err);
    return null;
  }
}

















  initializeIndividualATC() {
    // Add event listeners for individual ATC buttons
    this.querySelectorAll("[data-individual-atc]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        this.handleIndividualATC(btn);
      });
    });

    // Setup individual quantity handlers
    this.querySelectorAll(".individual-quantity-wrapper").forEach((wrapper) => {
      this.setupQuantityHandlers(wrapper, false); // false = is individual quantity
    });
  }

  handleIndividualATC(button) {
    const productId = button.dataset.productId;
    const variantId = button.dataset.variantId;
    const productTitle = button.dataset.productTitle;
    const productUrl = button.dataset.productUrl;

    if (!variantId) {
      console.error("Variant ID not available");
      return;
    }

    // Show loading state
    button.classList.add("loading");
    button.disabled = true;

    // Determine correct section ID based on current page
    let cartSectionID = "component-cart-drawer";
    if (window.globalSpace.template == "cart") {
      cartSectionID =
        document.getElementById("cart--items")?.dataset.id || "template-cart";
    }

    // Get the quantity from the quantity input field for this specific bundle item
    const quantityInput = button
      .closest(".individual-atc")
      .querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    // Get the form for this specific bundle item
    const form = button.closest("form");
    const formIndex = form.dataset.itemindex;

    // Use the reusable personalization data collection method
    const baseProperties = {
      _product_id: this.product_id,
      _bundle_price: this.pricing,
    };

    if (this.processing_time != "nil") {
      baseProperties["_processing_time"] = this.processing_time;
    }

    const personalizationResult = this.collectPersonalizationData(
      `#form-${Number(formIndex) + 1}${this.bundletype}`,
      baseProperties
    );

    // If validation failed, stop and reset button
    if (!personalizationResult) {
      button.classList.remove("loading");
      button.disabled = false;
      return;
    }

    let current_item_properties = personalizationResult.properties;
    let current_item_additional_cost = personalizationResult.additionalCost;

    if (current_item_additional_cost != 0) {
      current_item_properties[
        "additional cost"
      ] = `$${current_item_additional_cost.toFixed(2)}`;
    }

    // Prepare form data for individual item with properties

    const formData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: current_item_properties,
        },
      ],
      sections: `${cartSectionID},header`,
    };

    // Add to cart via AJAX
    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((dataJSON) => {
        if (dataJSON.errors) {
          console.error("Error adding to cart:", dataJSON.errors);
          return;
        }

        sessionStorage.removeItem("NumberOnBack");
        document.querySelectorAll("[data-personalization-input]").forEach?.(el => el.value = "");
        document.querySelectorAll("[data-selected-variant]").forEach(radio => {
          if (!radio.checked) {
            radio.click();
          }
        });

        BundleProduct.getEligibleBundleProductId().then(async (result) => {
          
          if (result) {
            const parentId = await BundleProduct.getCorrectCompleteBundleParent(
              result
            );

            if (parentId) {
              console.log("Final Parent Bundle to process:", parentId);
            }
          } else {
            console.log(" No matching product found");
          }
        });

        if (window.eventBus && window.PUB_SUB_EVENTS) {
          window.eventBus.publish(window.PUB_SUB_EVENTS.productATC, {
            data: {
              item: dataJSON.items[0],
            },
          });
        }

        if (document.querySelector("cart-form")) {
          document
            .querySelector("cart-form")
            ._updateCart(dataJSON.sections, button);
        } else {
          window.location.href = window.routes?.cart_fetch_url || "/cart";
        }
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
      })
      .finally(() => {
        button.classList.remove("loading");
        button.disabled = false;
      });
  }

  updateBundlePrice(update_qty) {
    const bundlePriceElement = this.querySelector("[data-bundle-price]");
    const bundleComparePriceElement = this.querySelector(
      "[data-bundle-compareprice]"
    );
    if (bundlePriceElement) {
      const updatedPrice = this.basePrice * update_qty;
      bundlePriceElement.innerHTML = Utility.formatMoney(
        updatedPrice,
        window.globalSpace.money_format
      );
    }
    if (bundleComparePriceElement && this.comparePrice) {
      const updatedComparePrice = this.comparePrice * update_qty;
      bundleComparePriceElement.innerHTML = Utility.formatMoney(
        updatedComparePrice,
        window.globalSpace.money_format
      );
    }
  }

  UpdateBulkItemSelection(currentVariant, element) {
    let index = element.closest("form").dataset.itemindex;
    
    
    if (currentVariant && currentVariant.available) {
      this.variableBox.verifiedItems[index] = currentVariant.id;
      this.UpdateVariantPersonalizeOptions(element, currentVariant.id);
      // Update individual ATC button for this item when normal inline bundle selected
    element.closest("form").querySelector("[data-bulkitemimg] img").src = currentVariant.featured_image ? currentVariant.featured_image.src : element.closest("form").querySelector("[data-bulkitemimg] img").dataset.defaultImg;
   
    if (this.bundletype == "normal") {
        this.updateIndividualATCButton(index, currentVariant.id, true);
      }
    } else {
      this.variableBox.verifiedItems[index] = false;
      this.ManageError("item not available");
      // Update individual ATC button for this item when normal inline bundle selected
      if (this.bundletype == "normal") {
        this.updateIndividualATCButton(index, false, false);
      }
    }

    if (this.variableBox.verifiedItems.some((e) => e == false)) {
      this.variableBox.submitBtnText.innerText = "Sold Out";
      this.variableBox.submitBtn.setAttribute("disabled", "true");
    } else {
      this.variableBox.submitBtnText.innerText = "Add to Cart";
      this.variableBox.submitBtn.removeAttribute("disabled");
    }
  }

  updateIndividualATCButton(index, variantId, isAvailable) {
    const individualForm = this.querySelector(`#form-${Number(index) + 1}`);
    if (!individualForm) return;
    const individualATCButton = individualForm.querySelector(
      "[data-individual-atc]"
    );
    if (individualATCButton) {
      // Update variant ID
      individualATCButton.dataset.variantId = variantId || "";
      // Update button state
      if (isAvailable && variantId) {
        individualATCButton.disabled = false;
        individualATCButton.querySelector(".add-text").textContent =
          "Add to cart";
      } else {
        individualATCButton.disabled = true;
        individualATCButton.querySelector(".add-text").textContent = "Sold Out";
      }
    }
  }

verifyData() {
  if (
    !(this.variableBox.totalItems == this.variableBox.verifiedItems.length)
  ) {
    this.ManageError("length compare");
    return;
  }

  if (this.variableBox.verifiedItems.some((e) => e == false)) {
    this.ManageError("Not all variants selected yet: verifyData function");
    return;
  }

  let quantity = this.querySelector(
    ".form-submit-wrapper [data-qty-input]"
  )?.value;

  // Existing logic (unchanged)
  this.variableBox.properties["_unique_id"] =
    this.variableBox.verifiedItems.join(":");

  this.variableBox.items = [];
  let flowstop = false;

  // Existing logic (unchanged)
  this.highestProperties = { ...this.variableBox.properties };

  this.variableBox.verifiedItems.forEach((id, index) => {
    let current_item_properties = { ...this.variableBox.properties };
    let current_item_additional_cost = 0;

    let current_item_personalize_inputs = this.querySelectorAll(
      `#form-${index + 1}${this.bundletype} .bulk-personalization input`
    );

    current_item_personalize_inputs.forEach((input) => {
      let type = input.type;
      let name = input.dataset.name;
      let input_value = input.value;
      let inputRequired = input.required;
      let inputLimit = Number(input.max);
      let checked_radio_stack = [];

      if (current_item_properties[name]) return;

      switch (type) {
        case "text":
          if (inputRequired && input_value == "") {
            this.personalizeErrorMsg(input, "Required Field");
            flowstop = true;
            break;
          }

          if (inputLimit && input_value.length > inputLimit) {
            this.personalizeErrorMsg(input, "Max Limit Exceeded");
            flowstop = true;
            break;
          }

          if (
            input.dataset.regex == "upper" &&
            input_value !== input_value.toUpperCase()
          ) {
            this.personalizeErrorMsg(
              input,
              "Input must be in uppercase letters"
            );
            flowstop = true;
            break;
          }

          if (
            input.dataset.regex == "number" &&
            !/^[0-9]+$/.test(input_value)
          ) {
            this.personalizeErrorMsg(input, "Input must be numeric only");
            flowstop = true;
            break;
          }

          if (input_value == "") break;

          current_item_properties[name] = input_value;
          if (!this.highestProperties[name]) {
            this.highestProperties[name] = input_value;
          }

          if (input.dataset.price) {
            current_item_additional_cost += Number(input.dataset.price);
          }
          break;

        case "radio":
          if (checked_radio_stack.includes(name)) break;

          let isInputChecked = input
            .closest("[data-parentelement]")
            .querySelector(`input[data-name="${name}"]:checked`);

          checked_radio_stack.push(name);

          if (
            inputRequired &&
            (!isInputChecked || isInputChecked.value == "N/a")
          ) {
            this.personalizeErrorMsg(input, "This Field is required");
            flowstop = true;
            break;
          }

          if (!input.checked) break;

          current_item_properties[name] = input_value;
          if (!this.highestProperties[name]) {
            this.highestProperties[name] = input_value;
          }

          if (input.dataset.price) {
            current_item_additional_cost += Number(input.dataset.price);
          }
          break;

        case "number":
          if (inputRequired && input_value == "") {
            this.personalizeErrorMsg(input, "Required Field");
            flowstop = true;
            break;
          }

          let input_max_limit = Number(input.dataset.max);
          if (input_max_limit && input_value.length > input_max_limit) {
            this.personalizeErrorMsg(input, "Max Limit Exceeded");
            flowstop = true;
            break;
          }

          if (input_value == "") break;

          current_item_properties[name] = input_value;
          if (!this.highestProperties[name]) {
            this.highestProperties[name] = input_value;
          }

          if (input.dataset.price) {
            current_item_additional_cost += Number(input.dataset.price);
          }
          break;
      }
    });

    // Consolidate individual personalization fields into a single "Personalization" property
    let personalizationText = "";
    const systemKeys = new Set(Object.keys(this.variableBox.properties).concat(["additional cost"]));
    const keysToRemove = [];
    for (const key of Object.keys(current_item_properties)) {
      if (!systemKeys.has(key) && !key.startsWith("_")) {
        personalizationText += `${key}: ${current_item_properties[key]}\n`;
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => delete current_item_properties[key]);
    if (personalizationText.trim()) {
      current_item_properties["Personalization"] = personalizationText.trim();
    }

    if (current_item_additional_cost != 0) {
      current_item_properties["additional cost"] =
        `$${current_item_additional_cost.toFixed(2)}`;
    }

    this.variableBox.items.push({
      id: id,
      quantity: quantity,
      properties: current_item_properties,
    });
  });

  // ✅ 🔐 GUARANTEED FIX (ONLY ADDITION)
  // Ensure _unique_custom_id EXISTS BEFORE ID GENERATION
  if (!this.highestProperties._unique_custom_id) {
    this.highestProperties._unique_custom_id =
      Math.random().toString(36).slice(2, 10);
  }

  // Keep state in sync (important for next steps)
  this.variableBox.properties._unique_custom_id =
    this.highestProperties._unique_custom_id;

  // Existing logic (unchanged)
  let bundle_unique_id = this.generateUniqueID(this.highestProperties);

  if (bundle_unique_id) {
    this.variableBox.items.forEach((item) => {
      item.properties["_bundle_unique_id"] = bundle_unique_id;
    });
  }

  if (flowstop) return;

  this.variableBox.submitBtn.classList.add("loading");
  this.bulkATC();
}


  bulkATC() {
    let cartSectionID = "component-cart-drawer";
    if (window.globalSpace.template == "cart") {
      cartSectionID =
        document.getElementById("cart--items")?.dataset.id || "template-cart";
    }
    let random = Math.random().toString(36).substring(2, 10);
    this.variableBox.properties["_unique_custom_id"] = `${random}`;

    this.variableBox.items.forEach((item) => {
      item.properties["_unique_custom_id"] = `${random}`;
    });
    let formData = {
      items: this.variableBox.items,
      sections: `${cartSectionID},header`,
    };
    
    

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((dataJSON) => {

        sessionStorage.removeItem("NumberOnBack");
        document.querySelectorAll("[data-personalization-input]").forEach?.(el => el.value = "");
        document.querySelectorAll("[data-selected-variant]").forEach(radio => {
          if (!radio.checked) {
            radio.click();
          }
        });

        this.querySelector("[data-qty-input]").value = 1;
        
        if (document.querySelector("cart-form")) {
          document
            .querySelector("cart-form")
            ?._updateCart(dataJSON.sections, this.variableBox.submitBtn);
        } else {
          return;
          window.location.href = window.routes.cart_fetch_url;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        this.variableBox.submitBtn.classList.remove("loading");
        document.querySelector("#bulk-custom-atc").hide();
      });
  }

  /**
   * Update Error Message
   */
  ManageError(place) {
    console.log("ERROR", place);
  }

  /**
   * Reusable method to collect and validate personalization data
   * @param {string} formSelector - CSS selector for the form (e.g., '#form-1', '#form-2')
   * @param {Object} baseProperties - Base properties to start with
   * @returns {Object} - Object with properties and additionalCost, or null if validation fails
   */
  collectPersonalizationData(formSelector, baseProperties = {}) {
    let current_item_properties = { ...baseProperties };
    let current_item_additional_cost = 0;
    let flowstop = false;
    // Get personalization inputs for the specific form
    let current_item_personalize_inputs = this.querySelectorAll(
      `${formSelector} .bulk-personalization input`
    );
    current_item_personalize_inputs.forEach((input) => {
      let type = input.type;
      let name = input.dataset.name;
      let input_value = input.value;
      let inputRequired = input.required;
      let inputLimit = Number(input.max);
      let checked_radio_stack = [];
      if (current_item_properties[name]) return;
      switch (type) {
        case "text":
          if (inputRequired && input_value == "") {
            this.personalizeErrorMsg(input, "Required Field");
            flowstop = true;
            break;
          }
          if (inputLimit && input_value.length > inputLimit) {
            this.personalizeErrorMsg(input, "Max Limit Exceeded");
            flowstop = true;
            break;
          }
          let isUppercase =
            input_value === input_value.toUpperCase() ? true : false;
          if (input.dataset.regex == "upper" && !isUppercase) {
            this.personalizeErrorMsg(
              input,
              "Input must be in uppercase letters"
            );
            flowstop = true;
            break;
          }
          let isNumberOnly = /^[0-9]+$/.test(input_value);
          if (input.dataset.regex == "number" && !isNumberOnly) {
            this.personalizeErrorMsg(input, "Input must be numeric only");
            flowstop = true;
            break;
          }
          if (input_value == "") break;
          current_item_properties[name] = input_value;
          if (input.dataset.price) {
            current_item_additional_cost += Number(input.dataset.price);
          }
          break;

        case "radio":
          if (checked_radio_stack.includes(name)) break;
          let isInputChecked = input
            .closest("[data-parentelement]")
            .querySelector(`input[data-name="${name}"]:checked`);
          checked_radio_stack.push(name);
          if (
            inputRequired &&
            (isInputChecked == null ||
              isInputChecked == undefined ||
              isInputChecked.value == "N/a")
          ) {
            this.personalizeErrorMsg(input, "This Field is required");
            flowstop = true;
            break;
          }
          if (!input.checked) break;
          current_item_properties[name] = input_value;
          if (input.dataset.price) {
            current_item_additional_cost += Number(input.dataset.price);
          }
          break;

        case "number":
          if (inputRequired && input_value == "") {
            this.personalizeErrorMsg(input, "Required Field");
            flowstop = true;
            break;
          }
          let input_max_limit = Number(input.dataset.max);
          if (input_max_limit && input_value.length > input_max_limit) {
            this.personalizeErrorMsg(input, "Max Limit Exceeded");
            flowstop = true;
            break;
          }
          if (input_value == "") break;
          current_item_properties[name] = input_value;
          if (input.dataset.price) {
            current_item_additional_cost += Number(input.dataset.price);
          }
          break;
      }
    });
    if (flowstop) {
      return null; // Validation failed
    }

    // Consolidate individual personalization fields into a single "Personalization" property
    let personalizationText = "";
    const systemKeys = new Set(Object.keys(baseProperties).concat(["additional cost"]));
    const keysToRemove = [];
    for (const key of Object.keys(current_item_properties)) {
      if (!systemKeys.has(key) && !key.startsWith("_")) {
        personalizationText += `${key}: ${current_item_properties[key]}\n`;
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => delete current_item_properties[key]);
    if (personalizationText.trim()) {
      current_item_properties["Personalization"] = personalizationText.trim();
    }

    return {
      properties: current_item_properties,
      additionalCost: current_item_additional_cost,
    };
  }
  personalizeErrorMsg(element, message) {
    let parentElement = element.closest("[data-parentElement]");
    if (parentElement) {
      parentElement.classList.add("enableError");
      parentElement.setAttribute("data-errorby", message);
      setTimeout(() => {
        parentElement.classList.remove("enableError");
        parentElement.removeAttribute("data-errorby");
      }, 5000);
    }
  }
  /**
   * Fetch the Variant personalize Options using the Section API;
   * We have created a dedicated section for this by the name of bulkitem-variant-personalize-api.
   */
  UpdateVariantPersonalizeOptions(variantselector, varaintid) {
    
    sessionStorage.setItem('SelectedVariantID', varaintid);
    let product_url = variantselector.dataset.producturl;
    let container = variantselector
      .closest("form")
      .querySelector("[data-bulk-personalize]");
    fetch(
      `${product_url}?variant=${varaintid}&sections=bulkitem-variant-personalize-api`
    )
      .then((r) => r.json())
      .then((dataJSON) => {
        if (!dataJSON["bulkitem-variant-personalize-api"]) return;
        let updatedHtml = new DOMParser().parseFromString(
          dataJSON["bulkitem-variant-personalize-api"],
          "text/html"
        );
        if (container) {
          container.innerHTML = updatedHtml.querySelector(
            "[data-bulk-personalize]"
          ).innerHTML;
        }
   container.querySelector('[data-personalization-input]')?.type === 'number' &&
(container.querySelector('[data-personalization-input]').value = sessionStorage.getItem('NumberOnBack') ?? '');

      })
      .catch((err) => {
        console.log("Error", err);
      });
  }
  /*
   *
   */
generateUniqueID(jsonData) {
  

  let length = Object.keys(jsonData).length;
  if (length == 0) return;

  let unique_data = [];

  for (let i in jsonData) {
    if (!unique_data.includes(jsonData[i])) {
      unique_data.push(jsonData[i]);
    }
  }

  let _id = unique_data.join("").replace(/\s+/g, "");

  return _id;
}


}
customElements.define("bundle-product", BundleProduct);

class BundleInitButtons extends HTMLElement {
  constructor() {
    super();
    // document.addEventListener('Drawer:Close', (e) => {
    //   // console.log(e.detail.element);
    //   document.querySelector('custom-drawer.quickshop-drawer.open')?.classList.remove('popup-opened');

    // });
  }
  connectedCallback() {
    this.dataAddAllATC = this.querySelector("[data-all-add-to-cart]");
    if (this.dataAddAllATC) {
      this.dataAddAllATC.addEventListener("click", () => {
        let popupslider = document.querySelector(
          'bundle-product[data-bundletype="popup"] swiper-container'
        );
        popupslider.swiper.slideTo(0, 0, false);
        document
          .querySelector("bundle-product.bundle-inline")
          .classList.add("d-none");
        this.containerDrawer = document.querySelector(
          ".custom-drawer.quickshop-drawer.open .quickshop-product-info"
        );
        this.containerDrawer?.classList.add("scroll-fixed");
      });
    }

    this.dataAddIndividually = this.querySelector("[data-add-individually]");
    if (this.dataAddIndividually) {
      this.dataAddIndividually.addEventListener("click", () => {
        let inline_forms = document.querySelector(
          "bundle-product.bundle-inline"
        );
        if (inline_forms) {
          inline_forms.classList.remove("d-none");
        }
        this.classList.add("d-none");
      });
    }
    document.addEventListener("Drawer:Close", (e) => {
      this.containerDrawer?.classList.remove("scroll-fixed");
    });
  }
}
customElements.define("bundle-init-buttons", BundleInitButtons);
